export default __webpack_public_path__ + "static/logo-multi-b60df461ed0af1c98bf1d82f8c547aba.svg";